import React from "react";
import Marquee from "react-fast-marquee";

export default function MarqueeStrip({ marquee = {} }) {
  const text = marquee.text || "SABOR INCONFUNDÍVEL • INGREDIENTES FRESCOS • EXPERIÊNCIA ÚNICA";
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-stone-800 bg-stone-950 py-6 md:py-8 overflow-hidden"
    >
      <Marquee speed={30} gradient={false} autoFill>
        <span className="font-serif text-3xl md:text-5xl text-stone-100 mx-8 flex items-center">
          {text}
          <span className="mx-8 text-amber-600">✦</span>
        </span>
      </Marquee>
    </section>
  );
}
